import React from "react";
import { Table } from "react-bootstrap";
import { Button, Spinner } from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import CustomReactSelect from "../../components/CustomReactSelect";
import { statusColor } from "../../components/TableStyle";

const MonthlyReimbursementTable = (props) => {
	return (
		<>
			<Table className="reimbursement-table" responsive>
				<thead className="reimburse-thead">
					<tr>
						{props.empDepartment === "5" && (
							<td style={{ borderRadius: "10px 0px 0px 0px" }}>
								<input
									checked={props.masterChecked}
									onChange={(e) => props.onMasterCheck(e)}
									type="checkbox"
								/>
							</td>
						)}
						<td
							style={
								props.empDepartment === "5"
									? null
									: { borderRadius: "10px 0px 0px 0px" }
							}
						>
							Token#
						</td>
						{props.empDepartment === "5" ? (
							<td colSpan={2}>Employee</td>
						) : (
							<td colSpan={2}>Created Date</td>
						)}
						<td>Reimbursement Month</td>
						<td colSpan={5} className="medical-col">
							Medical
						</td>
						<td colSpan={2} className="homeInternet-col">
							Home Internet
						</td>
						<td colSpan={2} className="mobile-col">
							Car/Mobile
						</td>
						{/* <td >Health</td> */}
						<td>Status</td>
						<td style={{ borderRadius: "0px 10px 0px 0px" }}>
							Grand Total
						</td>
					</tr>
					<tr className="sub-thead">
						<td></td>
						<td></td>
						{props.empDepartment === "5" ? (
							<td colSpan={2}></td>
						) : (
							<td></td>
						)}
						<td></td>
						<td className="medical-col" colSpan={2}>
							General OPD
						</td>
						<td className="medical-col">Parents</td>
						<td className="medical-col">Dental</td>
						<td className="medical-col">Maternity</td>
						<td className="homeInternet-col">Monthly</td>
						<td className="homeInternet-col">Others</td>
						<td className="mobile-col">Fuel/maintenance</td>
						<td className="mobile-col">Mobile</td>
						<td></td>
						<td></td>
					
					</tr>
				</thead>
				<tbody>
					{props.MonthlyReimbursementTableLoader ? (
						<tr>
							<td
								data-toggle="collapse"
								colSpan="20"
								className="noRecordContainer"
							>
								<Spinner />
							</td>
						</tr>
					) : props.monthlyReimburse.length === 0 ? (
						<tr>
							<td
								data-toggle="collapse"
								colSpan="20"
								className="noRecordContainer"
							>
								<div
									className="font-weight-bold mt-4"
									bis_skin_checked="1"
								>
									<span className="noRecord">
										NO RECORD FOUND
									</span>
								</div>
							</td>
						</tr>
					) : (
						props.monthlyReimburse.map((data, index) => {
							const {
								appID,
								goPatientAmt,
								parentAmt,
								dentistAmt,
								grandTotal,
								submissionStatus,
								internetMonthly,
								internetOther,
								carFuelMaintenance,
								mobileBill,
								maternityAmt,
								appliedDate,
								// healthClubBill,
								employeeName,
								selected,
								reimbursementMonth,
							} = data;
							return (
								<tr key={index}>
									{props.empDepartment === "5" && (
										<td>
											<input
												type="checkbox"
												checked={selected}
												onChange={(e) =>
													props.getSpecificReimbursementRecord(
														data,
														e
													)
												}
											/>
										</td>
									)}
									<td
										onClick={() =>
											props.viewMonthlyReimburseDetails(
												data.appID,
												data.submissionStatus,
												props.years
											)
										}
									>
										<Link
											style={{
												textDecoration: "none",
												fontWeight: "bold",
											}}
											className="tokenNumber"
											to={`/monthlyReimbursement/${appID}`}
										>
											<span className="ticketIdStyle">
												#{appID}
											</span>
										</Link>
									</td>
									{props.empDepartment === "5" ? (
										<td colSpan={2} className="medical-col">
											{employeeName}
										</td>
									) : (
										<td colSpan={2} className="medical-col">
											{moment(appliedDate).format(
												"DD/MM/YYYY"
											)}
										</td>
									)}
									<td className="medical-col">
										{moment(reimbursementMonth).format(
											"MMMM YYYY"
										)}
									</td>
									<td className="medical-col" colSpan={2}>
										{goPatientAmt.toLocaleString()}
									</td>
									<td className="medical-col">
										{parentAmt.toLocaleString()}
									</td>
									<td className="medical-col">
										{dentistAmt.toLocaleString()}
									</td>
									<td className="medical-col">
										{maternityAmt.toLocaleString()}
									</td>
									<td className="homeInternet-col">
										{internetMonthly.toLocaleString()}
									</td>
									<td className="homeInternet-col">
										{internetOther.toLocaleString()}
									</td>
									<td className="mobile-col">
										{carFuelMaintenance.toLocaleString()}
									</td>
									<td className="mobile-col">
										{mobileBill.toLocaleString()}
									</td>
									{/* <td className="mobile-col">
										{healthClubBill.toLocaleString()}
									</td> */}
									<td
										style={{
											color: statusColor(submissionStatus)
												.color,
										}}
									>
										{submissionStatus}
									</td>
									<td colSpan={2} className="medical-col">
										{grandTotal.toLocaleString()}
									</td>
								</tr>
							);
						})
					)}
				</tbody>
			</Table>
			{props.empDepartment === "5" ? (
				<div className="pl-3 pr-2 py-2 row justify-content-end align-items-center">
					<div className="col-xs-auto navigationsBtns">
						<Button
							disabled={props.pageNum === 1}
							icon={"Back"}
							className="btn prevPg btn-sm mr-2"
							onClick={props.paginateLeft}
						>
							{" "}
							Prev
						</Button>
						<Button
							disabled={
								props.numberOfItemsPerPage >=
									props.pagerData?.TotalCount ||
								props.monthlyReimburse.length === 0
							}
							icon={"Forward"}
							className="btn nextPg btn-sm"
							onClick={props.paginateRight}
						>
							Next
						</Button>
					</div>
					<div className="col-xs-auto">
						<span className="mr-2 ml-2 pager-content">
							{" "}
							Showing
						</span>
						{props.pageNum}
					</div>
					<div className="mx-2" style={{ width: "100px" }}>
						{" "}
						<CustomReactSelect
							paginationDropDown={true}
							options={props.menuProps}
							value={{
								value: props.numberOfItemsPerPage,
								label: props.numberOfItemsPerPage,
							}}
							onChange={(value) => {
								props.receiveData(value.value);
							}}
							isDisabled={
								props.numberOfItemsPerPage >=
								props.pagerData?.TotalCount
							}
						/>
					</div>
					<div className="col-xs-auto">
						of
						<span className="mr-2 ml-2 pager-content">
							{props.pagerData?.TotalCount}
						</span>
					</div>
				</div>
			) : null}
		</>
	);
};
export default MonthlyReimbursementTable;
